import React from 'react';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../../../sessionStorage';
import { useLocation, useNavigate } from 'react-router-dom';

import AboutData from './AboutData';
import FaqData from './FaqData';
import PolicyCostData from './PolicyCostData';
import PurchasingProcessData from './PurchasingProcessData';
import ProductCarriers from './ProductCarriers';
import UniversalLifeArticleData from './UniversalLifeArticleData';
import UniversalLifeAboutMeForm from '../../../../Quoters/UniversalLife/steps/AboutMeForm';
import { getPrimaryColor } from '../../../../Quoters/Common/Helpers/Utility';

export default function UniversalLifeData(props) {
  const primaryBrandColor = getPrimaryColor();
  const minAgeDays = 14;
  const minAge = 0;
  const maxAge = 80;
  const minCoverageAmount = 50000;
  const maxCoverageAmount = 10000000;
  const navigate = useNavigate();
  const location = useLocation();
  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);

  const accountProductTypeSettings = accountObj.accountProducts.find(product => product.productLandingUrl === location.pathname);
  const accountLandingOverride = accountObj.accountOverrides && accountProductTypeSettings ?
    accountObj.accountOverrides.find(override => override.accountProductTypeId === accountProductTypeSettings.productTypeId) : null;

  const universalLifeForm = (<UniversalLifeAboutMeForm
    ageSpecs={{ minAgeDays: minAgeDays, min: minAge, max: maxAge }}
    onNext={() => {
      navigate('/universal-life/select-appointment');
    }}
    brandTheme={primaryBrandColor}
    showHeader={false}
    submitButtonVariant={'landing'}
    isUniversalLife={props.isUniversalLife}
    ref = {props.aboutMeFormRef}
  />);

  const defaultValueProposition = [{
    title: " Universal Life Insurance",
    subtitle: "Lifetime Protection",
    subtitleExtended: "Affordable coverage from top rated companies - saving for the future and protecting your loved ones has never been easier.",
  }];

  return {
    name: 'Universal Life Insurance',
    subtitle: 'Lifetime Protection - Today',
    footerMessage: "Get peace of mind and universal life insurance",
    footerButtonName: "CONTINUE",
    heroText: accountLandingOverride ? JSON.parse(accountLandingOverride.valueProposition) : defaultValueProposition,
    basicInfoForm: () => {
      return universalLifeForm;
    },
    about: AboutData(minAgeDays, maxAge, minCoverageAmount, maxCoverageAmount),
    purchasingProcess: PurchasingProcessData(),
    policyCost: PolicyCostData(),
    faq: FaqData(),
    termArticle: UniversalLifeArticleData(),
    productCarriers: ProductCarriers(),
    isAddDefaultFaq: false,
  };
}
